import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CustomToastrService {
  constructor(private toastr: ToastrService) { }
 message(message: string, title: string, options?: Partial<ToastrOptions>) {
    const type = options?.messageType || ToastrMessageType.Warning;
    const position = options?.position || ToastrPosition.TopRight;

    this.toastr[type](message, title, {
      positionClass: position,
      timeOut: 2500
    });
  }

}

export class ToastrOptions {
  messageType?: ToastrMessageType;
  position?: ToastrPosition
}

export enum ToastrMessageType {
  Success = "success",
  Info = "info",
  Warning = "warning",
  Error = "error"
}

export enum ToastrPosition {
  TopRight = "toast-top-right",
  BottomRight = "toast-bottom-right",
  BottomLeft = "toast-bottom-left",
  TopLeft = "toast-top-left",
  TopFullWidth = "toast-top-full-width",
  BottomFullWidth = "toast-bottom-full-width",
  TopCenter = "toast-top-center",
  BottomCenter = "toast-bottom-center"
}
